module.exports = __webpack_public_path__ + "img/aiimg6.f7b8501b.png";